import React, { useEffect, useState } from 'react'
import {FaInfo, FaLock} from 'react-icons/fa'
import { store } from '../../stores/store'

import './Aep.css'

import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore'


function showDesc(desc) {
  PopupStore.open(POPUPS_IDS.ADVISOR, desc)
}

function Aep({data, categ, selected, prevSelected, onClick}) {

  let rule = window.applyAvailabilityRules(data.id, store.allChosenAepIds, store.currentSelectedAepIds, store.t)

  let available = false
  let msg = ""

  if(rule) {
    available = rule.available
    msg = rule.msg
  }

  if(store.remainingAepChanges === 0 && store.aepIdsDiffCategs.indexOf(categ) === -1) {
    available = false
    msg = store.t("no_remaining_changes")
  }

  function handleClick (){
    if(available && onClick) onClick()
  }

  let cl = "aep"
  cl += selected ? " selected" : ""
  cl += prevSelected ? " prev-selected" : ""
  if(!selected) {
    cl += !available ? " disabled" : ""
  }

  return (
    <div className={cl}>
      <div onClick={handleClick} title={data.id}  className="name" dangerouslySetInnerHTML={{__html: data.title}} />
      <button className="info" onClick={() => {showDesc(data.description)}}><FaInfo /></button>
      {!available && <button className="lock" onClick={() => {showDesc(msg)}}><FaLock /></button>}
    </div>
  )
}

export default Aep